$(function () {
    $(".clipboard-copy").click(function () {
        var copyTextarea = document.querySelector('#' + $(this).data('id'));
        copyTextarea.select();
        document.execCommand('copy');
    });
});